import styled, {css, CSSProperties, DefaultTheme} from 'styled-components'
import {typography} from '@/theme/typography'
import {PaletteKey} from '@/components/ui/text/Text'

interface StyledTextProps {
    $weight?: CSSProperties['fontWeight']
    $size?: keyof typeof typography
    $palette?: PaletteKey
    $shade?: keyof DefaultTheme['palette'][PaletteKey]
}

export const StyledText = styled.p<StyledTextProps>(
    ({theme: {palette, typography}, $palette, $size, $weight, $shade}) => {
        const paletteVariantToCss = {
            primary: css`
                color: ${palette.primary[$shade || '600']};
            `,
            neutral: css`
                color: ${palette.neutral[$shade || '950']};
            `,
            success: css`
                color: ${palette.success[$shade || '800']};
            `,
            warning: css`
                color: ${palette.warning[$shade || '800']};
            `,
            danger: css`
                color: ${palette.danger[$shade || '800']};
            `,
            orange: css`
                color: ${palette.orange[$shade || '800']};
            `,
            green: css`
                color: ${palette.green[$shade || '800']};
            `
        } as const satisfies Record<PaletteKey, ReturnType<typeof css>>

        return css`
            ${$size && typography[$size]};
            ${$palette && paletteVariantToCss[$palette]}
            ${$weight &&
            css`
                font-weight: ${$weight};
            `}
        `
    }
)
